import React from 'react';

import {NOT_ARCHIVED_PURPOSE_STRING} from 'archive/ArchiveConstants';
import {MinimalFolder} from 'constants/FolderConstants';
import * as GlobalSearchActions from 'search/GlobalSearchActions';
import {GlobalSearchResponse} from 'search/GlobalSearchDAO';
import {Filter, FilterKey, Operator, SearchParams, SearchType, SortKey} from 'search/SearchConstants';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import SelectTree, {LoadMorePromise} from 'ui-library/select-tree/SelectTree';

import * as FileSelectorConstants from './FileSelectorConstants';
import * as FileSelectorUtil from './FileSelectorUtil';
// @ts-expect-error
import GetFoldersWrapper from './GetFoldersWrapper';

interface Props {
  fetchLimit: number;
  fileFilter: Array<Filter>;
  folderFilter: FileSelectorConstants.FileSelectorFolderFilter;
  onChange: (ids: Array<string>) => void;
  value: Array<string>;
}

const buildFileFilters = (passedFilters: Array<Filter>, folderId: string): Array<Filter> =>
  passedFilters.concat([
    {key: FilterKey.FOLDER, operator: Operator.IS, value: folderId},
    {
      key: FilterKey.ARCHIVE_PURPOSES,
      operator: Operator.IS_ONE_OF,
      value: [NOT_ARCHIVED_PURPOSE_STRING],
    },
  ]);

const MultipleFilesSelector = (props: Props): JSX.Element => {
  const loadMore = async (folderId: string, offset: number): LoadMorePromise => {
    const params: SearchParams = {
      offset,
      limit: props.fetchLimit,
      sorts: [{key: SortKey.SORT_MODIFIED_AT_KEY, reverse: true}],
      filters: buildFileFilters(props.fileFilter, folderId),
      query: '',
    };
    const response = (await GlobalSearchActions.doGlobalSearch(
      params,
      SearchType.GLOBAL
    )) as GlobalSearchResponse;

    return {
      items: Object.values(response.fileSummariesById).map((file) =>
        FileSelectorUtil.fileToSelectTreeItem(file)
      ),
      more: offset + props.fetchLimit < response.total,
      offset,
    };
  };

  return (
    <GetFoldersWrapper folderFilter={props.folderFilter}>
      {(folders: Array<MinimalFolder> | null) =>
        !folders ? (
          <div className="u-small-padding-bottom text-center">
            <HorizontalThrobber />
          </div>
        ) : (
          <SelectTree
            selectedIds={props.value}
            onChangeSelectedIds={props.onChange}
            multiple={true}
            items={FileSelectorUtil.foldersToSelectTreeItems(folders)}
            loadMore={loadMore}
          />
        )
      }
    </GetFoldersWrapper>
  );
};

export default MultipleFilesSelector;
